/* ============================================
   ランドセル予約LP — lp-randoseru.js
   AJAX Cart + Size Tool + GA4 + Toast + Tabs
   ============================================ */

(function() {
  'use strict';

  /* ------------------------------------------
     AJAX CART
     ------------------------------------------ */
  var AjaxCart = {
    init: function() {
      var buttons = document.querySelectorAll('[data-lp-add-to-cart]');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          AjaxCart.addToCart(btn);
        });
        btn.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            AjaxCart.addToCart(btn);
          }
        });
      });
    },

    addToCart: function(btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var variantId = btn.getAttribute('data-variant-id');
      var productName = btn.getAttribute('data-product-name');
      var productPrice = btn.getAttribute('data-product-price');
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      var controller = new AbortController();
      var timeoutId = setTimeout(function() { controller.abort(); }, 3000);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        signal: controller.signal
      })
      .then(function(res) {
        clearTimeout(timeoutId);
        if (!res.ok) {
          return res.json().then(function(data) {
            throw { status: res.status, message: data.message || data.description || '' };
          });
        }
        return res.json();
      })
      .then(function(data) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        Toast.show(productName);
        GA4.addToCart(variantId, productName, productPrice);
      })
      .catch(function(err) {
        clearTimeout(timeoutId);
        btn.classList.remove('is-loading');

        if (err.status === 422) {
          btn.classList.add('is-soldout');
          btn.textContent = '完売しました';
          btn.disabled = true;
        } else {
          btn.disabled = false;
          Toast.showError('通信エラーが発生しました。もう一度お試しください。');
        }
      });
    }
  };

  /* ------------------------------------------
     TOAST NOTIFICATION
     ------------------------------------------ */
  var Toast = {
    el: null,
    timer: null,

    init: function() {
      this.el = document.getElementById('lp-toast');
    },

    show: function(productName) {
      if (!this.el) return;
      var titleEl = this.el.querySelector('.lp-toast__title');
      var productEl = this.el.querySelector('.lp-toast__product');
      if (titleEl) titleEl.textContent = 'カートに追加しました';
      if (productEl) productEl.textContent = productName || '';
      this.el.classList.add('is-visible');
      this.el.setAttribute('aria-live', 'polite');

      clearTimeout(this.timer);
      this.timer = setTimeout(function() { Toast.hide(); }, 5000);
    },

    showError: function(message) {
      if (!this.el) return;
      var titleEl = this.el.querySelector('.lp-toast__title');
      var productEl = this.el.querySelector('.lp-toast__product');
      if (titleEl) {
        titleEl.textContent = 'エラー';
        titleEl.style.color = '#DC2626';
      }
      if (productEl) productEl.textContent = message;
      var actions = this.el.querySelector('.lp-toast__actions');
      if (actions) actions.style.display = 'none';
      this.el.classList.add('is-visible');

      clearTimeout(this.timer);
      this.timer = setTimeout(function() {
        Toast.hide();
        if (titleEl) titleEl.style.color = '';
        if (actions) actions.style.display = '';
      }, 4000);
    },

    hide: function() {
      if (!this.el) return;
      this.el.classList.remove('is-visible');
    }
  };

  /* ------------------------------------------
     TAB SWITCHING (GUIDE)
     ------------------------------------------ */
  var Tabs = {
    init: function() {
      var tabs = document.querySelectorAll('[data-lp-tab]');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          Tabs.switchTo(tab.getAttribute('data-lp-tab'));
        });
      });
    },

    switchTo: function(panelId) {
      document.querySelectorAll('[data-lp-tab]').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('[data-lp-panel]').forEach(function(p) {
        p.classList.remove('is-active');
      });

      var activeTab = document.querySelector('[data-lp-tab="' + panelId + '"]');
      var activePanel = document.querySelector('[data-lp-panel="' + panelId + '"]');
      if (activeTab) {
        activeTab.classList.add('is-active');
        activeTab.setAttribute('aria-selected', 'true');
      }
      if (activePanel) activePanel.classList.add('is-active');
    }
  };

  /* ------------------------------------------
     (Sizer removed — single model, no size variants)
     ------------------------------------------ */
  var Sizer = { init: function() {} };

  /* ------------------------------------------
     SCROLL CTA (smooth scroll)
     ------------------------------------------ */
  var ScrollCTA = {
    init: function() {
      var links = document.querySelectorAll('[data-lp-scroll]');
      links.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.querySelector(link.getAttribute('data-lp-scroll'));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  };

  /* ------------------------------------------
     FADE-IN (IntersectionObserver)
     ------------------------------------------ */
  var FadeIn = {
    init: function() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.lp-fade-in').forEach(function(el) {
          el.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      document.querySelectorAll('.lp-fade-in').forEach(function(el) {
        observer.observe(el);
      });
    }
  };

  /* ------------------------------------------
     GA4 TRACKING (via dataLayer / GTM)
     ------------------------------------------ */
  var GA4 = {
    push: function(data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    },

    viewItemList: function() {
      var cards = document.querySelectorAll('[data-lp-add-to-cart]');
      var items = [];
      cards.forEach(function(btn, i) {
        items.push({
          item_id: btn.getAttribute('data-variant-id'),
          item_name: btn.getAttribute('data-product-name'),
          price: parseFloat(btn.getAttribute('data-product-price')) || 0,
          index: i
        });
      });
      if (items.length === 0) return;
      GA4.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_name: 'ランドセル予約LP',
          items: items
        }
      });
    },

    addToCart: function(variantId, name, price) {
      GA4.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'JPY',
          value: parseFloat(price) || 0,
          items: [{
            item_id: variantId,
            item_name: name,
            price: parseFloat(price) || 0,
            quantity: 1
          }]
        }
      });
    },

    scrollDepth: function() {
      if (!('IntersectionObserver' in window)) return;
      var sections = document.querySelectorAll('[data-lp-section]');
      var tracked = {};
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var name = entry.target.getAttribute('data-lp-section');
            if (!tracked[name]) {
              tracked[name] = true;
              GA4.push({ event: 'section_view', section_name: name });
            }
          }
        });
      }, { threshold: 0.3 });

      sections.forEach(function(s) { observer.observe(s); });
    }
  };

  /* ------------------------------------------
     INIT
     ------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    AjaxCart.init();
    Toast.init();
    Tabs.init();
    Sizer.init();
    ScrollCTA.init();
    FadeIn.init();
    GA4.viewItemList();
    GA4.scrollDepth();

    /* Toast close button */
    var closeBtn = document.querySelector('.lp-toast__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { Toast.hide(); });
    }

    /* Toast continue button */
    var continueBtn = document.querySelector('.lp-toast__continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', function() { Toast.hide(); });
    }
  });

})();
